import React from 'react';
import './TableCanvas.css';

export const TableCanvas = ({ plotTableFn }) => {
    return (
        <div className="table-panel">
            {plotTableFn && plotTableFn()}
        </div>
    );
};